export function paginatedCanonical(baseUrl: string, page: number): string {
    return page > 1 ? `${baseUrl}?page=${page}` : baseUrl;
}

/**
 * Сохраняет активные фильтры в UI, но не создаёт лишний `?page=1`.
 * Индексируемая пагинация начинается со второй страницы.
 */
export function paginationHref(
    pathname: string,
    currentSearchParams: URLSearchParams,
    page: number | string
): string {
    const params = new URLSearchParams(currentSearchParams);
    const pageNumber = Number(page);

    if (pageNumber <= 1) {
        params.delete('page');
    } else {
        params.set('page', String(pageNumber));
    }

    const query = params.toString();
    return query ? `${pathname}?${query}` : pathname;
}
